import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  {
    title: 'SBR',
    icon: { icon: PageMeta.Sbr.Icon },
    children: [
      {
        page: PageMeta.Sbr.Submissions,
        title: PageMeta.Sbr.Submissions.Title,
        icon: { icon: PageMeta.Sbr.Submissions.Icon },
        to: PageMeta.Sbr.Submissions.Name,
      },
    ],
  },
]
